<template>
  <div class="eventEditor">
    <div class="eventEditorIn">
      <el-row type="flex" align="middle" justify="center" class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">会议申请人</el-col>
        <el-col :span="16" class="alignLeft public_font">{{ eventForm.applicant }}</el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">会议组织者</el-col>
        <el-col :span="16" class="alignLeft">
          <popover-table placeholder="请选择会议组织者" inputWidth='calc(100% - 20px)' v-if="isShowEdit"
                         class="width280 public_font" :oldData="eventForm.organizer" @getRowData="setOrganizerData"
                         v-model="eventForm.organizer" selectField="cName" :tableTitle="organizeTitle"
                         :tableData="employeeList" :total="total" :pageSize="5" :pageIndex="pageIndex" :inputSearch="queryAsync">
          </popover-table>
          <span v-else>{{ eventForm.organizer }}</span>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft public_font">
          <p class="verify_item" style="margin: 0">会议费用</p>
          <p class="iconTxt">（不含讲课费）</p>
        </el-col>
        <el-col :span="16" class="alignLeft">
          <el-select v-if="isShowEdit" v-model="eventForm.eventSize" placeholder="请选择会议费用"
                     @change="valueChange('eventSize')" class="width280 public_font">
            <el-option v-for="(item,index) in selectForm.eventSizeList" :key="index" :label="item"
                       :value="item">
            </el-option>
          </el-select>
          <span v-else>{{ eventForm.eventSize }}</span>
          <p style="color: #969799;font-size: 12px" v-if="eventForm.isPlanMeeting">计划会议预算（含讲课费）：{{eventForm.budgetAmount}}</p>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item" v-if="eventForm.eventSize == '5W以上'">
        <el-col :span="8" class="alignLeft verify_item public_font">PO操作人</el-col>
        <el-col :span="16" class="alignLeft">
          <popover-table placeholder="请选择PO操作人" inputWidth='calc(100% - 20px)' v-if="isShowPOEdit"
                         class="width280 public_font" v-model="eventForm.cName" selectField="cName"
                         :tableTitle="organizeTitle"
                         :tableData="POByMarkerList" :total="total" :pageSize="5" :pageIndex="pageIndex"
                         @getRowData="getPORowData" :inputSearch="queryPoAsync">
          </popover-table>
          <span v-else>{{ eventForm.cName }}</span>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">会议名称</el-col>
        <el-col :span="16" class="alignLeft">
          <el-input v-if="isShowEdit" v-model="eventForm.name" placeholder="请填写会议名称"
                    class="width280 public_font" @input='lengthJudgment("会议名称", "name")'></el-input>
          <span v-else>{{ eventForm.name }}</span>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">会议性质</el-col>
        <el-col :span="16" class="alignLeft">
          <el-select v-if="isShowEdit" v-model="eventForm.nature" @change="valueChange('nature')"
                     placeholder="请选择会议性质" class="width280 public_font">
            <el-option v-for="(item,index) in selectForm.natureList" :key="index" :label="item.txt"
                       :value="item.val">
            </el-option>
          </el-select>
          <span v-else>{{ eventForm.natureTxt }}</span>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">会议类型</el-col>
        <el-col :span="16" class="alignLeft">
          <el-select v-if="isShowEdit" v-model="eventForm.typeDictTxt" @change="valueChange('typeDictTxt')"
                     placeholder="请选择会议类型" class="width280 public_font">
            <el-option v-for="(item,index) in selectForm.typeList" :key="index" :label="item.val"
                       :value="item.val">
            </el-option>
          </el-select>
          <span v-else>{{ eventForm.typeDictTxt }}</span>
        </el-col>
      </el-row>
      <el-row v-if="eventForm.typeDictTxt === '内部计划会'">
        <el-col :span="8"><p style="color: transparent">1</p></el-col>
        <el-col :span="16">
          <p class="typeDictTips">患者顾问作为常设小组成员，临时参与罗氏内部计划会议，确立罗氏与患者的双向反馈机制。</p>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item" v-if="eventForm.nature">
        <el-col :span="8" class="alignLeft verify_item public_font">{{ [1, '1'].includes(eventForm.nature) ? '治疗领域' : '疾病领域'}}</el-col>
        <el-col :span="16" class="alignLeft">
          <el-select v-if="isShowEdit" v-model="eventForm.diseaseArea"  @change="valueChange('diseaseArea')"
                     placeholder="请选择疾病领域" class="width280 public_font">
            <el-option v-for="(item,index) in selectForm.diseaseAreaList" :key="index"
                       :label="item.diseaseName" :value="item.diseaseName">
            </el-option>
          </el-select>
          <span v-else>{{ eventForm.diseaseArea }}</span>
        </el-col>
      </el-row>
      <!-- v-if="eventForm.nature != '非推广'" -->
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">产品</el-col>
        <el-col :span="16" class="alignLeft">
          <el-select v-if="isShowEdit" v-model="eventForm.product"
                     placeholder="请选择产品" class="width280 public_font">
            <el-option v-for="(item,index) in selectForm.productList" :key="index" :label="item.brandName"
                       :value="item.brandName">
            </el-option>
          </el-select>
          <span v-else>{{ eventForm.product }}</span>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">会议城市</el-col>
        <el-col :span="16" class="alignLeft">
          <el-select v-if="isShowEdit" v-model="eventForm.city" placeholder="请选择会议城市"
                     @change="valueChange('city')" filterable class="width280 public_font">
            <el-option v-for="(item,index) in selectForm.cityList" :key="index" :label="item.txt"
                       :value="item.txt">
            </el-option>
          </el-select>
          <span v-else>{{ eventForm.city }}</span>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft public_font" :class="model.status == 30 ? 'verify_item' : ''">
          是否网络会议
        </el-col>
        <el-col :span="16" class="alignLeft">
          <el-select v-model="eventForm.vMettingType" @change="valueChange('vMettingType')"
                     placeholder="请选择是否网络会议" class="width280">
            <el-option v-for="(item,index) in selectForm.vMettingList" :key="index" :label="item"
                       :value="index">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row v-if="eventForm.vMettingType && eventForm.vMettingType != '线下'" type="flex" align="middle"
              class="item">
        <el-col :span="8" class="alignLeft  public_font">是否使用A1视频会议</el-col>
        <el-col :span="16" class="alignLeft">
          <el-select v-model="eventForm.isUseAOne" @change="valueChange('isUseAOne')"
                     placeholder="请选择是否使用A1视频会议" class="width280">
            <el-option v-for="(item,index) in selectForm.hasSpeakerList" :key="index" :label="item"
                       :value="index">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row type="flex"
              v-if=" eventForm.vMettingType && (selectForm.hasSpeakerList[eventForm.isUseAOne] == '否' || eventForm.isUseAOne == '否')"
              align="middle" class="item">
        <el-col :span="8" class="alignLeft public_font">网络会议参会人链接</el-col>
        <el-col :span="16" class="alignLeft">
          <el-input v-model="eventForm.vMettingUrl" placeholder="请填写网络会议参会人链接"
                    class="width280 public_font"></el-input>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">院内/院外</el-col>
        <el-col :span="16" class="alignLeft">
          <el-select v-if="isShowEdit" v-model="eventForm.isHospital" placeholder="请选择院内/院外" class="width280">
            <el-option v-for="(item,index) in selectForm.isHospitalList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
          <span v-else>{{ eventForm.isHospital }}</span>
          <p v-if="isShowEdit" class="typeDictTips">请根据会议开展的地点填写院内开展还是院外召开。</p>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft public_font"
                :class="eventForm.vMettingType == 1 ? '' : 'verify_item'">会议地点</el-col>
        <el-col :span="16" class="alignLeft">
          <el-input v-if="isShowEdit" v-model="eventForm.address" placeholder="请填写会议地点"
                    class="width280 public_font" @input='lengthJudgment("会议地点", "address")'>
            <svg slot="append" class="icon" aria-hidden="true" @click="editMap" style="width: 25px; height: 25px;cursor: pointer">
              <use xlink:href="#icon-ditu"></use>
            </svg>
          </el-input>
          <span v-else>{{ eventForm.address }}</span>
        </el-col>
      </el-row>
      <el-row v-if="isSHowHospital" type="flex" align="middle"
              class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">医院名称</el-col>
        <el-col :span="16" class="alignLeft" @click.native="queryHospital">
          <popover-table :showToolTip="true" placeholder="请选择医院" inputWidth='calc(100% - 20px)'
                         v-if="isShowEdit" class="public_font" :oldData='eventForm.hospitalName'
                         @getRowData="valueChange('hospitalName')" v-model="eventForm.hospitalName"
                         selectField="name" :tableTitle="hospitalTitle" :tableData="hospitalData"
                         :total="hospitalTotal" :pageSize="5" :pageIndex="pageIndex"
                         :inputSearch="queryHospital">
          </popover-table>
          <span v-else>{{ eventForm.hospitalName }}</span>
        </el-col>
      </el-row>
      <el-row v-if="isSHowHospital" type="flex" align="middle"
              class="item">
        <el-col :span="8" class="alignLeft public_font"
                :class="{'verify_item':eventForm.typeDictTxt == '院内会' ? false : true}">科室
        </el-col>
        <el-col :span="16" class="alignLeft">
          <el-select v-if="isShowEdit" v-model="eventForm.hospitalDept" placeholder="请选择科室"
                     class="width280 public_font">
            <el-option v-for="(item,index) in sectionData" :key="index" :label="item.txt" :value="item.txt">
            </el-option>
          </el-select>
          <span v-else>{{ eventForm.hospitalDept }}</span>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">会议时间段</el-col>
        <el-col :span="16" class="alignLeft">
          <el-select v-if="isShowEdit" v-model="eventForm.dtTypeTxt" placeholder="请选择会议时段"
                     class="width280 public_font">
            <el-option v-for="(item,index) in selectForm.eventDateList" :key="index" :label="item.txt"
                       :value="item.txt">
            </el-option>
          </el-select>
          <span v-else>{{ eventForm.dtTypeTxt }}</span>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">开始日期</el-col>
        <el-col :span="16" class="alignLeft">
          <el-date-picker v-if="isShowEdit" v-model="eventForm.dtStart" value-format="yyyy-MM-dd"
                          placeholder="请选择开始日期" @change="valueChange('dtStart')"
                          :picker-options="pickerOptions" class="width280">
          </el-date-picker>
          <span v-else>{{ eventForm.dtStart | formatDate }}</span>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">结束日期</el-col>
        <el-col :span="16" class="alignLeft">
          <el-date-picker v-if="isShowEdit" v-model="eventForm.dtEnd" value-format="yyyy-MM-dd"
                          placeholder="请选择结束日期" @change="valueChange('dtEnd')" :picker-options="pickerOptions"
                          class="width280">
          </el-date-picker>
          <span v-else>{{ eventForm.dtEnd | formatDate }}</span>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">会议人数</el-col>
        <el-col :span="16" v-if="isShowEdit" class="alignLeft public_font">
          内部:
          <el-input-number :controls="false" v-model="eventForm.qtyAttenderInt" placeholder="请选择内部人数" :min="0" :max="999999999999"
                           class="width120"></el-input-number>
          外部:
          <el-input-number :controls="false" v-model="eventForm.qtyAttenderExt" placeholder="请选择外部人数" :min="0" :max="999999999999"
                           class="width120"></el-input-number>
        </el-col>
        <el-col :span="16" v-else class="alignLeft public_font">
          内部:<span>{{ eventForm.qtyAttenderInt }}</span>
          外部:<span>{{ eventForm.qtyAttenderExt }}</span>
        </el-col>
      </el-row>
      <el-row v-if="isShowHasSpeaker" type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">是否有讲者</el-col>
        <el-col :span="16" class="alignLeft">
          <el-select v-if="isShowEdit" v-model="eventForm.hasSpeaker" placeholder="请选择是否有讲者"
                     @change="valueChange('hasSpeaker')" class="width280">
            <el-option v-for="(item,index) in selectForm.hasSpeakerList" :key="index" :label="item"
                       :value="item">
            </el-option>
          </el-select>
          <span v-else>{{ eventForm.hasSpeaker }}</span>
        </el-col>
      </el-row>
      <el-row v-if="isShowHasSpeaker && eventForm.hasSpeaker==='是' && showSpeakerType" type="flex" align="middle"
              class="item">
        <el-col :span="8" class="alignLeft verify_item public_font">讲者类型</el-col>
        <el-col :span="16" class="alignLeft">
          <el-checkbox-group v-model="eventForm.speakerType">
            <el-checkbox v-for="(item,index) in selectForm.speakerTypeList" :label="item.value"
                         :disabled="!isShowEdit"
                         v-if="(item.isShow && item.isShow == eventForm.typeDictTxt) || !item.isShow"
                         :key="index">{{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>
      <el-row
        v-if="isShowHasSpeaker && eventForm.hasSpeaker==='是' && showSpeakerType && eventForm.speakerType && eventForm.speakerType.includes(2)"
        type="flex" align="middle" class="item">
        <el-col :span="8">
        </el-col>
        <el-col :span="16" class="alignLeft">
          <p :style="{color: (eventForm.speakerType && eventForm.speakerType.includes(2) ? '#aaa' : 'transparent')}"
             style="text-align: right;font-size: 12px">若为患者组织公对公付款，请联系采购同事。</p>
        </el-col>
      </el-row>

      <el-row type="flex" align="middle" class="item">
        <el-col :span="8" class="alignLeft public_font">GSD单号</el-col>
        <el-col :span="16" class="alignLeft">
          <el-input v-model="eventForm.GSDNumber" placeholder="请填写GSD单号"
                    class="width280 public_font" @input='lengthJudgment("请填写GSD单号", "GSDNumber")'></el-input>
        </el-col>
      </el-row>
      <el-row type="flex" align="start" class="item">
        <el-col :span="8" class="alignLeft public_font">备注</el-col>
        <el-col :span="16" class="alignLeft">
          <el-input type="textarea" v-model="eventForm.descr" placeholder="请填写备注"
                    class="width280 public_font"></el-input>
        </el-col>
      </el-row>

      <el-row class="footer">
        <el-button class="width100 falseBtn" v-on:click.native="doAsync(false)">
          取消
        </el-button>
        <el-button class="width100 sureBtn" :loading="btnLoading" v-on:click.native="doAsync(true)">
          确定
        </el-button>
      </el-row>
    </div>
    <map-editor ref="mapEditor"></map-editor>
  </div>
</template>

<script>
    import { mapMutations} from "vuex";
    import eventEditorData from '@scripts/components/eventEditor.js'
    import employeeSelector from '@scripts/components/employeeSelector.js'
    import POByMarkerSelect from '@scripts/components/POByMarkerSelect.js'
    import hospitalSelector from '@scripts/components/hospitalSelector.js'
    import popoverTable from './popoverTable'
    import mapEditor from "./mapEditor";
    export default {
        mixins: [eventEditorData, employeeSelector, hospitalSelector, POByMarkerSelect],
        components: {
            popoverTable,
          mapEditor
        },
        data() {
            return {
                doType: true,
                loading: false,
                editDate: false,
                btnLoading: false,
                showSpeakerType: false,
                model: {
                    itsExtData: {}
                },
                tips: '',
                isShowOrganizePopover: false, // isShowpopover
                organizeTitle: [{
                    titleId: 'cName',
                    titleText: '姓名'
                }, {
                    titleId: 'identifyCode',
                    titleText: '员工号'
                }, {
                    titleId: 'dept',
                    titleText: '部门'
                }],
                hospitalTitle: [{
                    titleId: 'name',
                    titleText: '医院名称'
                }, {
                    titleId: 'level',
                    titleText: '医院等级'
                }, {
                    titleId: 'city',
                    titleText: '所在城市'
                }],
                hospitalData: [],
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now();
                    }
                }
            }
        },
        computed: {
            isShowEdit() {
                return this.model.status != 30
            },
            isShowPOEdit() {
                return this.model.status <= 50 || !this.isEditEvent
            }
        },
        //watch还没找到公用的方法，暂时各自分开写，后面找到方法替换   ---   TODO
        //鉴于app和web组件的区别，绑定值和取值方式不一样，可能还需要一点小方法区分对待，公用的还是需要抽离出来的
        watch: {
            eventForm: {
                handler: "listenEventForm",
                deep: true
            },
        },
        mounted: function () {
            this.pageSize = 5;
            this.queryAsync({
                type: 'web'
            }); // 获取组织者人员
            this.queryPoAsync({
                type: 'web'
            }); // 获取PO人员
        },
        created() {
            this.loading = true;
            this.FnDictionaryQuery(); //科室
            this.getEventData();
            this.getme();

        },
        methods: {
            ...mapMutations(["setNewEventForm", "resetNewEventForm", "setCityId"]),
            // 获取个人信息
            async getme() {
                var response = await this.api.post(this.url.identity.getme, {b: '2'});
                if (response && response.success) {
                    this.$store.commit("setPersonal", response.content);
                } else {
                  this.$message.error('获取个人信息失败!');
                }
            },
            lengthJudgment (item, vModel) {
              console.log(vModel)
              if(this.eventForm[vModel] && this.eventForm[vModel].length > 50) {
                this.$message.error(`${item} 长度不能超过50个文字`);
                return
              }
            },
            // 会议名称过滤
            formatter() {
                let isEmoji = /(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])/g.test(this.eventForm.name)
                return isEmoji
            },
            // 判断是否显示
            decideShow(type) {
                switch (type) {
                    // 是否有医院
                    case 'isSHowHospital':
                        this.isSHowHospital = ["科室会", "院内会"].includes(this.eventForm.typeDictTxt);
                        return;
                    // 是否有讲者and讲者类型
                    case 'isShowHasSpeaker':
                        this.isShowHasSpeaker = false;
                        if ( this.seapkerAuth && this.eventForm.typeDictTxt && this.eventForm.nature && this.selectForm.natureList.length > 0 ) {
                            this.isShowHasSpeaker = this.selectForm.natureList.filter(ele => {
                                    return [ele.val].includes(this.eventForm.nature);
                                })[0].itsExtData.eventTypes.filter(val => {
                                    return [val.val].includes(this.eventForm.typeDictTxt)
                                })[0].forbidSpeaker ? false : true;
                            this.showSpeakerType = this.selectForm.natureList.filter(ele => {
                                    return [ele.val].includes(this.eventForm.nature)
                                })[0].itsExtData.eventTypes.filter(val => {
                                    return [val.val].includes(this.eventForm.typeDictTxt);
                                })[0].hasSpeakerType ? true : false;
                            if (!this.showSpeakerType) {
                                this.eventForm.speakerType = []
                            }
                        }
                        return;
                }
            },
            // 选项值改变触发
            valueChange(parameter) {
                switch (parameter) {
                    //监听上线城市，以获取上线医院
                    case 'city':
                        this.selectForm.cityList.map(ele => {
                            if (ele.txt == this.eventForm.city) {
                                var params = {
                                    provinceId: ele.provinceId,
                                    cityId: ele.cityId,
                                    type: 'web'
                                }
                                this.QueryHospitalConfig(params); //医院
                            }
                        });
                        this.clearHospital()
                        return;
                    //监听会议类型取值，判断是否有讲课费，决定是否可选择是否有讲者，若无讲课费，默认传值false，反之可选择此项！
                    case 'typeDictTxt':
                        this.clearHospital()
                        this.decideShow('isSHowHospital')
                        this.decideShow('isShowHasSpeaker')
                        this.eventForm.speakerType = []
                        return;
                    //监听会议性质，再进行选择会议类型、产品、疾病领域
                    case 'nature':
                        let isEditPlan = false
                        if (this.eventForm.isPlanMeeting && this.isChange && ![this.eventForm.nature].includes(this.model.itsExtData.property)) {
                            isEditPlan = true
                        }
                        if (isEditPlan) {
                            this.$confirm('<div style="text-align: left"><p>由于您更改了会议部分重要信息：</p><p>1.会议性质 <p>会议提交后需要预算审批</p><p> 确认修改吗</p></div>', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                dangerouslyUseHTMLString: true,
                                center: true,
                                type: 'warning'
                            }).then(() => {
                                this.isChange = false
                                this.editNature()
                            }).catch(() => {
                              if (this.model.itsExtData && this.model.itsExtData.property) {
                                this.$set(this.eventForm, 'nature', this.model.itsExtData.property.toString())
                              }
                            });
                        } else {
                            this.editNature()
                        }
                        return;
                    //监听领域，同步产品list
                    case 'diseaseArea':
                        this.eventForm.product = ""; //产品
                        this.selectForm.productList = [];
                        this.selectForm.diseaseAreaList.map(ele => {
                            if (ele.diseaseName == this.eventForm.diseaseArea) {
                                this.selectForm.productList = ele.dieases;
                            }
                        });
                        this.loading = false;
                        return;
                    //监听会议费用
                    case 'eventSize':
                        if (this.eventForm.eventSize != '5W以上') {
                            this.eventForm.cName = ''
                            this.eventForm.accountName = ''
                        }
                        return;
                    case 'hasSpeaker':
                        if (this.eventForm.hasSpeaker === '否') {
                            this.eventForm.speakerType = []
                        }
                        return;
                    case 'hospitalName':
                        this.hospitalData.map((ele) => {
                            if (ele.name == this.eventForm.hospitalName) {
                                this.eventForm.hospitalId = ele.rowId;
                                this.eventForm.hospitalCode = ele.code
                                this.eventForm.hospitalEl = ele.el
                                this.eventForm.hospitalNl = ele.nl
                            }
                        })
                        return;
                    case 'hasSpeaker':
                        if (this.eventForm.hasSpeaker === '否') {
                            this.eventForm.speakerType = []
                        }
                        return;
                    case 'eventSize':
                        if (this.eventForm.eventSize != '5W以上') {
                            this.eventForm.cName = ''
                            this.eventForm.accountName = ''
                        }
                        return;
                    case 'dtStart':
                      // 计划会议只能在本季度内修改会议时间
                      let result = true
                      if (this.eventForm.isPlanMeeting) {
                        let isYear = [new Date(this.model.dtStart).getFullYear()].includes(new Date(this.eventForm.dtStart).getFullYear())
                        let isQuarter = [Math.ceil((new Date(this.model.dtStart).getMonth()+1) / 3)].includes(Math.ceil((new Date(this.eventForm.dtStart).getMonth()+1) / 3))
                        result = isYear && isQuarter
                      }
                      if (!result) {
                        this.$confirm('<div style="text-align: left"><p>会议计划，只能在季度范围内修改会议开始日期</p></div>', '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          dangerouslyUseHTMLString: true,
                          showCancelButton:false,
                          center: true,
                          type: 'warning'
                        }).then(() => {
                          this.$set(this.eventForm, 'dtStart', new Date(this.model.dtStart))
                        })
                        return
                      }
                      this.editDtStart()
                        return;
                    case 'dtEnd':
                        if (new Date(this.eventForm.dtEnd) < new Date(this.eventForm.dtStart)) {
                            this.$message.error("结束时间不能小于开始时间");
                            this.eventForm.dtEnd = "";
                        }
                        return;
                    case 'vMettingType':
                        if (this.eventForm.vMettingType == 0) {
                            this.eventForm.isUseAOne = ''
                            this.eventForm.vMettingUrl = ''
                        } else {
                            this.eventForm.isUseAOne = '是'
                        }
                        return;
                    case 'isUseAOne':
                        if (this.eventForm.isUseAOne == 0) {
                            this.eventForm.vMettingUrl = ''
                        }
                        return;
                }
            },
            // 编辑会议性质
            editNature () {
                this.eventForm.typeDictTxt = ""; //会议类型
                this.selectForm.typeList = [];
                this.eventForm.product = ""; //产品
                this.selectForm.productList = [];
                this.eventForm.diseaseArea = ""; //疾病领域
                this.selectForm.diseaseAreaList = [];
                this.getTypeList()
                this.decideShow('isShowHasSpeaker')
                this.loading = false;
                this.isEditEvent = false
                this.isEdit = false;
            },
            // 编辑会议开始时间
            editDtStart () {
                // 结束时间默认是开始时间
                if (!this.editDate || (new Date(this.eventForm.dtEnd) < new Date(this.eventForm.dtStart))) {
                    this.eventForm.dtEnd = this.eventForm.dtStart;
                    this.editDate = false;
                }
            },
            // 清除医院信息
            clearHospital() {
                this.eventForm.hospitalCode = ''; //医院code
                this.eventForm.hospitalId = '';//医院id
                this.eventForm.hospitalName = '';//医院名称
                this.eventForm.hospitalDept = '';//科室
            },
            //监听对象数据更新，同步更新到store中
            listenEventForm() {
                this.setNewEventForm(this.eventForm);
            },
            //获取编辑会议从A1传过来的值
            getEventData() {
                let model = this.iStorage.get('model') || ''
                this.tips = ''
                if (!model) return
                if (model.addType == 'edit') {
                    this.model = this.iStorage.get('model').editEventForm
                    this.isEditEvent = true;
                    this.editDate = true;
                    if (this.model.status == 10) {
                        this.tips = this.model.itsExtData.isPlanMeeting ? `<div style="text-align: left">
                      <p style="color:red">修改会议信息后，会议预算、费用分摊、日程信息可能需要重新录入，请确认是否要继续修改会议信息</p>
                      <p>1.修改组织者，需要重新录入预算、费用分摊</p>
                      <p>2.修改会议费用，需要重新录入预算、日程</p>
                      <p>3.修改会议性质，需要重新录入预算、日程，并且会议提交后需要审批</p>
                      <p>4.修改会议类型，需要重新录入预算、日程</p>
                      <p>5.修改会议开始日期、结束日期，需要重新录入日程</p>
                    </div>` : `<div style="text-align: left">
                      <p style="color:red">修改会议信息后，会议预算、费用分摊、日程信息可能需要重新录入，请确认是否要继续修改会议信息</p>
                      <p>1.修改后需要重新录入预算的：组织者、会议费用、会议类型</p>
                      <p>2.修改后需要重新录入费用分摊的：组织者</p>
                      <p>3.修改后需要重新录入日程的：会议费用、会议类型、开始日期、结束日期</p>
                    </div>`
                    }
                    this.iStorage.set('editEventForm', this.iStorage.get('model').editEventForm); //为了同APP逻辑同步
                } else {
                    this.iStorage.remove('editEventForm')
                }
            },
            // 执行按钮操作
            doAsync(type) {
                if (this.formatter()) {
                    this.$message.error('会议名称请勿输入表情');
                    return
                }
                if (this.eventForm.name && this.eventForm.name.length > 50) {
                  this.$message.error(`会议名称 长度不能超过50个文字`);
                  return
                }
                if (this.eventForm.address && this.eventForm.address.length > 50) {
                  this.$message.error(`会议地点 长度不能超过50个文字`);
                  return
                }
                if (this.eventForm.GSDNumber && this.eventForm.GSDNumber.length > 50) {
                  this.$message.error(`GSD单号 长度不能超过50个文字`);
                  return
                }
                if (this.eventForm.vMettingType == 0 && this.hasRocheOnlineMeeting && this.eventForm.status == 30 && type) {
                    this.$message.error("您已添加罗氏线上会议平台（锐医）需求，请先删除需求后再进行操作");
                    return
                }
                if (this.tips && type) {
                    this.$confirm(this.tips, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        dangerouslyUseHTMLString: true,
                        center: true,
                        type: 'warning'
                    }).then(() => {
                        this.saveAsyncFun(type)
                    }).catch(() => {});
                } else {
                    this.saveAsyncFun(type)
                }

            },
            saveAsyncFun (type) {
                this.doType = type;
                if (this.doType) {
                    if (Number(this.eventForm.qtyAttenderInt) > Number(this.eventForm.qtyAttenderExt)) {
                        this.$message.error('内部人数不能超总人数的50%');
                        return false;
                    }
                    this.btnLoading = true
                    this.saveAsync({
                        onSuccess: (response) => {
                            this.btnLoading = false
                            console.log(response) //在此拿会议id，查看详情TODO
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            })
                            this.postMessage();
                        },
                        toast: null,
                        $messageError: (error) => {
                            this.btnLoading = false
                            this.$message.error(error)
                        }
                    });
                } else {
                    this.postMessage();
                    return;
                }
            },
            postMessage() {
                let data = {
                    from: "simulator",
                    to: "eventEditor",
                    type: this.doType
                };
                window.parent.postMessage(data, "*");
            },
            // 兼容app端
            selected() {

            },
            getPORowData(val, p) {
                this.eventForm.accountName = val.accountName
            },
            //监听组织者变化，刷新会议性质list  --TODO
            setOrganizerData(val) {
                if (this.eventForm.tuUserId !== val.userId) {
                    this.eventForm.organizer = val.cName
                    this.eventForm.tuUserId = val.userId
                    this.eventForm.department = val.dept
                    if (this.eventForm.nature) {
                        this.eventForm.nature = ''
                        this.selectForm.natureList = []
                        this.eventForm.typeDictTxt = ""; //会议类型
                        this.selectForm.typeList = [];
                        this.eventForm.product = ""; //产品
                        this.selectForm.productList = [];
                        this.eventForm.diseaseArea = ""; //疾病领域
                        this.selectForm.diseaseAreaList = [];
                    }
                    this.GetEventProperty('noEdit'); //会议性质根据组织者决定的，需要组织者的id来获取
                }
            },
            // 兼容app端
            setRequired() {

            },
            queryHospital (val = {}) {
                this.selectForm.cityList.map(ele => {
                    if (ele.txt == this.eventForm.city) {
                        var params = {
                            provinceId: ele.provinceId,
                            cityId: ele.cityId,
                            type: 'web'
                        }
                        this.eventForm.provinceId = ele.provinceId
                        this.eventForm.cityId = ele.cityId
                        Object.assign(params, val)
                        this.QueryHospitalConfig(params); //医院
                    }
                });
            },
          editMap () {
            this.$refs.mapEditor.show({
              title: '选择会议地点',
              sourceKey: 'address',
            })
          },
          // 更新表单
          updateForm(options) {
            this.eventForm.address = options.address;
          },
        },
        filters: {
            formatDate: function (strTime) {
                if (!strTime) {
                    return null;
                }
                let date = new Date(strTime);
                let month = (date.getMonth() + 1);
                month = month >= 10 ? month : ("0" + month);
                let day = date.getDate();
                day = day >= 10 ? day : ("0" + day);
                return date.getFullYear() + "-" + month + "-" + day
            }
        }
    }
</script>

<style scoped>
  @import '../assets/css/public.css';

  .el-checkbox {
    margin-right: 0;
  }

  .eventEditor {
    width: 520px;
    margin: 0 auto;
    padding: 0 0 50px;
    color: #666666;
    font-size: 16px;
  }

  .eventEditorIn {
    padding: 0 20px;
  }

  .item {
    padding: 10px 0;
  }

  .footer {
    margin: 20px 0 0;
  }

  .typeDictTips {
    margin: auto;
    font-size: 12px;
    color: #aaa;
    text-align: right;
  }
  .iconTxt {
    color: red;
    margin: 0;
    font-size: 12px;
  }
</style>

<style>
  .public_font {
    color: #606266 !important;
    font-size: 14px !important;
    font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
  }

  .public_font .el-input__inner {
    color: #606266 !important;
    font-size: 14px !important;
    font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
  }

  .public_font .el-textarea__inner {
    color: #606266 !important;
    font-size: 14px !important;
    font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
  }

  .public_font .el-textarea__inner::-webkit-input-placeholder {
    color: #CCCCCC;
    font-size: 11px;
  }

  .public_font .el-textarea__inner:-moz-placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }

  .public_font .el-textarea__inner::-moz-placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }

  .public_font .el-textarea__inner:-ms-input-placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }

  .verify_item:after {
    content: '*';
    color: red;
  }

  .eventEditor .el-col-8 {
    width: 140px !important;
  }

  .eventEditor .el-col-16 {
    width: calc(100% - 140px) !important;
  }

  .eventEditor .width280 {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/eventEditor.vue